module.exports = __webpack_public_path__ + "media/assets/images/blog/nosco_remote_interface-small-8b7633c6854b213760649442acaf2478.jpg";